import { render } from "./LocaleDropdown.vue?vue&type=template&id=2a67b94d"
import script from "./LocaleDropdown.vue?vue&type=script&lang=js"
export * from "./LocaleDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__